import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ADMIN_DASHBOARD:
      return action.payload;
    case type.FETCH_MANAGER_DASHBOARD:
      return action.payload;
    default:
      return state;
  }
};
